module.exports = __webpack_public_path__ + "img/image_modal_join.60b00eff.png";